import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { logoImageSx } from "@/components/brand/logoImageSx";

function BrandLogo({
  compact = false,
  height,
  logoHeight,
  showBadge = false,
  badgeText = "ERP",
}) {
  const imgHeight = height ?? logoHeight ?? (compact ? 28 : 32);
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        minWidth: 0,
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src="/logo-main.png"
        alt="GPS WALA"
        className="erp-brand-logo-img"
        sx={logoImageSx(imgHeight)}
      />
      {(showBadge || !compact) && (
        <Chip
          label={badgeText}
          size="small"
          variant="outlined"
          sx={{
            ml: showBadge ? 1 : 0,
            height: 18,
            fontSize: "0.62rem",
            fontWeight: 800,
            borderRadius: "4px",
            letterSpacing: "0.04em",
            color: "primary.main",
            borderColor: "primary.main",
            "& .MuiChip-label": { px: 0.75 },
          }}
        />
      )}
    </Box>
  );
}

export { BrandLogo as default };
